module.exports = __webpack_public_path__ + "static/media/recursos-materiais-01.0d2759f5.png";